<div *ngIf="tableauRoadmapConfig && !isRetool">
  <app-tableau-iframe [config]="tableauRoadmapConfig"> </app-tableau-iframe>
</div>

<div class="retool-app" *ngIf="isRetool">
  <app-retool-iframe [embeddedURLRequest]="retoolRoadmapConfig"></app-retool-iframe>
</div>
